


























import Vue from 'vue';
import { templateTokens } from '../common';


export default Vue.extend({
  name: 'Templated',
  props: {
    template: {
      type: String,
      required: true,
    },
    textStyle: {
      type: Object,
      default: null,
    },
  },
  computed: {
    parts(): Array<{ name: string, index: number, text: boolean, section: boolean }> {
      return templateTokens(this.template).map((name, index) => ({
        name,
        index,
        text: index % 2 === 0 && !!name,
        section: index % 2 === 1,
      }));
    },
  },
});
